import React, { ChangeEvent, FC, useEffect, useState } from 'react';

// material-ui
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';

// project imports
import QuotesList from './quotes';
import MainCard from 'ui-component/cards/MainCard';

// assets
import { useAgencyStore } from 'Application/store';
import { getAgencyIdFromStorage } from 'Application/utils';
import { QuoteStatus } from 'Application/models';
import { Box, Divider, FormControl, InputLabel, Select, SelectChangeEvent, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import Loader from 'ui-component/Loader';

// ==============================|| USER LIST STYLE 1 ||============================== //

const getEnumFromString = (value: string): QuoteStatus | undefined => {
    return QuoteStatus[value as keyof typeof QuoteStatus];
};

interface GeneratedQuotesProps {
    agencyId: number;
}

//! Failed & Pending Quotations component
export const GeneratedQuotes: FC<GeneratedQuotesProps> = ({ agencyId }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (numberOfRows: number) => {
        setPageSize(numberOfRows);
        setAnchorEl(null);
    };

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);

    const quotationStatusOptions = ['ALL', ...Object.values(QuoteStatus).map((statusOption) => statusOption)];
    const [quotationStatus, setQuotationStatus] = useState<string>(quotationStatusOptions[0]);

    const [quotationNumber, setQuotationNumber] = useState<string>('');
    const handleQuotationNumberChange = (e: ChangeEvent<HTMLInputElement>) => setQuotationNumber(e.target.value);

    const {
        getAgencyQuotations,
        agencyQuotationsData,
        isLoading: isGetQuotationsLoading,
        isError: isGetQuotationsError,
        error: getQuotationsError
    } = useAgencyStore((state) => ({
        getAgencyQuotations: state.getAgencyQuotations,
        agencyQuotationsData: state.agencyQuotationsData,
        isLoading: state.isLoading,
        isError: state.isError,
        error: state.error
    }));

    const handleQuotationStatusChange = (newQuotationStatus: string) => {
        setQuotationStatus(newQuotationStatus);
    };

    const quotationStatusOption = getEnumFromString(quotationStatus);

    useEffect(() => {
        getAgencyQuotations(agencyId, page, pageSize, quotationStatusOption, quotationNumber);
    }, [page, pageSize, quotationStatus]);

    const handleQuotationNumberSearch = async () => {
        await getAgencyQuotations(agencyId, page, pageSize, quotationStatusOption, quotationNumber);
    };

    console.log(`Is the get policies loading: ${isGetQuotationsLoading}`.toUpperCase())
    console.log(`Is agenciesPolicyData null: ${agencyQuotationsData}`.toUpperCase())

    return (
        <>
            <Grid container className="flex items-center">
                <Grid item xs={12} sm={4} className="mb-4 sm:mb-0">
                    <Typography>Filter by status or search for a specific quotation</Typography>
                </Grid>
                <Grid item xs={12} sm={8} className="flex items-center sm:flex-row flex-col sm:space-x-2 space-y-2 sm:space-y-0">
                    <Box className="sm:w-1/2 w-full">
                        <FormControl fullWidth>
                            <InputLabel id="quote-status-label">Quote Status</InputLabel>
                            <Select
                                size="small"
                                labelId="quote-status-label"
                                id="quote-status"
                                value={quotationStatus}
                                fullWidth
                                label="Quote Status"
                                variant="outlined"
                                onChange={(e: SelectChangeEvent) => handleQuotationStatusChange(e.target.value)}
                            >
                                {quotationStatusOptions.map((quoteStatusOption) => (
                                    <MenuItem key={quoteStatusOption} value={quoteStatusOption}>
                                        {quoteStatusOption.toTitle()}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box className="sm:w-1/2 w-full">
                        <TextField
                            size="small"
                            id="quoteNumber"
                            label="Quote Number"
                            variant="outlined"
                            value={quotationNumber}
                            onChange={handleQuotationNumberChange}
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Search className="hover:cursor-pointer" onClick={handleQuotationNumberSearch} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>

            <Divider className="my-6" />

            <Box>
                {isGetQuotationsLoading || agencyQuotationsData === null ? (
                    <Loader />
                ) : (isGetQuotationsError ? (
                    <Typography color="error">{getQuotationsError}</Typography>
                ) : (
                    <>
                        <QuotesList agencyQuotations={agencyQuotationsData} />

                        {agencyQuotationsData.totalPages > 1 && (
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Pagination
                                    className="mt-6"
                                    count={agencyQuotationsData.totalPages}
                                    page={page}
                                    onChange={(event, value) => setPage(value)}
                                    color="primary"
                                />
                                {/* {anchorEl && (
                            <Menu
                                id="menu-user-list-style1"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                variant="selectedMenu"
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                            >
                                <MenuItem onClick={() => handleClose(10)}> 10 Rows</MenuItem>
                                <MenuItem onClick={() => handleClose(20)}> 20 Rows</MenuItem>
                                <MenuItem onClick={() => handleClose(30)}> 30 Rows </MenuItem>
                            </Menu>
                         )} */}
                            </Grid>
                        )}
                    </>
                ))}
            </Box>
        </>
    );
};

export const AgencyUserGeneratedQuotes = () => {
    const agencyId: number = getAgencyIdFromStorage()!;

    return (
        <MainCard title={<Typography variant="h3">Generated Quotes</Typography>}>
            <GeneratedQuotes agencyId={agencyId} />
        </MainCard>
    );
};
